import type { PatientStrings } from '../index';

export const pa: PatientStrings = {
  titleOne: 'ਤੁਹਾਡਾ ਨਵਾਂ ਕ੍ਰਾਊਨ',
  titleMany: 'ਤੁਹਾਡੇ ਨਵੇਂ ਕ੍ਰਾਊਨ',
  tooth: 'ਦੰਦ',
  teeth: 'ਦੰਦ',
  both: 'ਦੋਵੇਂ',
  overview: 'ਪੂਰਾ ਦ੍ਰਿਸ਼',
  front: 'ਸਾਹਮਣੇ ਤੋਂ',
  leftSide: 'ਖੱਬਾ ਪਾਸਾ',
  rightSide: 'ਸੱਜਾ ਪਾਸਾ',
  bitingSurface: 'ਚਬਾਉਣ ਵਾਲੀ ਸਤ੍ਹਾ',
  show: 'ਦਿਖਾਓ',
  newCrown: 'ਨਵਾਂ ਕ੍ਰਾਊਨ',
  newCrowns: 'ਨਵੇਂ ਕ੍ਰਾਊਨ',
  yourTeeth: 'ਤੁਹਾਡੇ ਦੰਦ ਅਤੇ ਮਸੂੜੇ',
  upperTeeth: 'ਉੱਪਰਲੇ ਦੰਦ',
  lowerTeeth: 'ਹੇਠਲੇ ਦੰਦ',
  hint: 'ਘੁਮਾਉਣ ਲਈ ਖਿੱਚੋ · ਜ਼ੂਮ ਲਈ ਪਿੰਚ ਜਾਂ ਸਕ੍ਰੋਲ ਕਰੋ',
  zoomIn: 'ਨੇੜੇ',
  zoomOut: 'ਦੂਰ',
  turnSlowly: 'ਹੌਲੀ ਘੁਮਾਓ',
  stopTurning: 'ਘੁਮਾਉਣਾ ਰੋਕੋ',
  backToStart: 'ਸ਼ੁਰੂਆਤ ਤੇ ਵਾਪਸ',
  fullScreen: 'ਪੂਰੀ ਸਕ੍ਰੀਨ',
  exitFullScreen: 'ਪੂਰੀ ਸਕ੍ਰੀਨ ਤੋਂ ਬਾਹਰ',
  fromDentist: 'ਤੁਹਾਡੇ ਡੈਂਟਿਸਟ ਵੱਲੋਂ',
  shadeNote: (shade) =>
    `ਰੰਗ ਲਗਭਗ ਸ਼ੇਡ ${shade} ਵਰਗਾ ਦਿਖਾਇਆ ਗਿਆ ਹੈ। ਅਸਲੀ ਕ੍ਰਾਊਨ ਦਾ ਰੰਗ ਲੈਬ ਵਿੱਚ ਮਿਲਾਇਆ ਜਾਂਦਾ ਹੈ।`,
  before: 'ਪਹਿਲਾਂ',
  after: 'ਬਾਅਦ',
  seeInRoom: 'ਆਪਣੇ ਕਮਰੇ ਵਿੱਚ ਦੇਖੋ',
  arNotSupported: 'ਕ੍ਰਾਊਨ ਨੂੰ ਆਪਣੇ ਕਮਰੇ ਵਿੱਚ ਦੇਖਣ ਲਈ ਇਹ ਪੰਨਾ ਆਪਣੇ ਫ਼ੋਨ ਤੇ ਖੋਲ੍ਹੋ।',
  appointmentTitle: 'ਕ੍ਰਾਊਨ ਲਗਵਾਉਣ ਦੀ ਤੁਹਾਡੀ ਅਪਾਇੰਟਮੈਂਟ',
  confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ',
  confirmed: 'ਪੁਸ਼ਟੀ ਹੋ ਗਈ — ਫਿਰ ਮਿਲਦੇ ਹਾਂ',
  anotherTime: 'ਹੋਰ ਸਮਾਂ ਮੰਗੋ',
  anotherTimeSent: 'ਅਸੀਂ ਤੁਹਾਡੇ ਡੈਂਟਿਸਟ ਨੂੰ ਦੱਸ ਦਿੱਤਾ ਹੈ ਕਿ ਤੁਹਾਨੂੰ ਹੋਰ ਸਮਾਂ ਚਾਹੀਦਾ ਹੈ।',
  language: 'ਭਾਸ਼ਾ',
  largerText: 'ਵੱਡੇ ਅੱਖਰ',
};
